import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=36204934&scoped=true&"
import script from "./CModal.vue?vue&type=script&lang=js&"
export * from "./CModal.vue?vue&type=script&lang=js&"
import style0 from "./CModal.vue?vue&type=style&index=0&id=36204934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36204934",
  null
  
)

export default component.exports